<h3>{{ "NAV_DEVICE_MANAGEMENT" | translate }}</h3>

<div class="pt-3">
        <div 
            class="toolbar-row-grid"
            [ngStyle]="{'display': mobileScreen ? 'unset' : 'grid', 'gap': '10px'}"
            >
        <!-- First row's buttons -->
        <div class="d-flex"
            [ngStyle]="{'margin-top': 'auto', 'gap': '10px'}"
            >
            <!-- Add new device -->
            @if (Areas.Devices | can: 'ReadWrite') {
            <button
                id="addDeviceBtn"
                class="btn btn-primary"
                (click)="addNewBase()"
            >
                <span class="fa-light fa-fw fa-plus"></span>
                {{ "ADD_NEW_DEVICE" | translate }}
            </button>
            }

            <!-- Add new location -->
             @if (Areas.Locations | can: 'ReadWrite') {
            <button
                id="addLocationBtn"
                data-testid="add-new-location"
                class="btn btn-outline-primary"
                (click)="addNewLocation()">
                <span class="fa-light fa-fw fa-plus"></span>
                {{ "ADD_NEW_LOCATION" | translate }}
            </button>
            }

            <!-- Download locations CSV -->
             @if (deviceList) {
            <button
                class="btn btn-outline-primary"
                (click)="exportDeviceList()">
                <span class="fa-light fa-download"></span>
                {{ "DOWNLOAD_CSV" | translate }}
            </button>
            }
        </div>

        <!-- Show search bar after devices have been loaded -->
        <div class="search" [hidden]="!devicesLoaded">
            <!-- Filter for visible columns -->
            <div class="mr-2">
            <app-multiselect-dropdown
            [options]="columnOptions"
            [label]="'VISIBLE_COLUMNS' | translate"
            [selected]="visibleColumns"
            [enableSearch]="false"
            [showSelectAll]="true"
            [onMobileScreen]="mobileScreen"
            (selectedChange)="onColumnSelectionChange($event)">
            </app-multiselect-dropdown>
            </div>
            <div 
                class="flex-grow mr-2">
                <input
                  type="text"
                  #deviceSearchInput
                  class="form-control border border-secondary"
                  placeholder="{{ 'SEARCH' | translate }}... "
                  (keydown.enter)="onEnterKeydown($event)"
                />
            </div>
            <button 
                id="deviceManagementSearch"
                class="btn btn-primary" #deviceSearchButton
                [ngStyle]="{'max-height': mobileScreen ? '38px' : 'none'}"
                >
                <span class="fa-light fa-magnifying-glass"></span>
                {{ "SEARCH" | translate }}
            </button>
        </div>
    </div>

    <!-- Second row's buttons -->
    <div class="toolbar-row-flex">
        <!-- Show or hide expanding panels -->
         @if (deviceList && !locationsCollapsed && !devicesCollapsed && !manuallyCollapsed) {
        <button
            class="btn btn-outline-dark disabled toggleHideBtn">
            <span class="fa-light fa-fw fa-minus"></span>
        </button>
        }

        @if (deviceList && (locationsCollapsed || devicesCollapsed || manuallyCollapsed)) {
        <button
            class="btn btn-outline-primary toggleHideBtn"
            matTooltip="{{ 'TOOLTIP_COLLAPSE_DEVICES' | translate }}"
            (click)="handleCollapsing(false)">
            <span class="fa-light fa-fw fa-minus"></span>
        </button>
        }

        @if (deviceList && locationsCollapsed && devicesCollapsed && !manuallyCollapsed) {
        <button
            class="btn btn-outline-dark disabled toggleExpandBtn">
            <span class="fa-light fa-fw fa-plus"></span>
        </button>
        }

        @if (deviceList && (!locationsCollapsed || !devicesCollapsed || manuallyCollapsed)) {
        <button
            class="btn btn-outline-primary toggleExpandBtn"
            matTooltip="{{ 'TOOLTIP_EXPAND_DEVICES' | translate }}"
            (click)="handleCollapsing(true)">
            <span class="fa-light fa-fw fa-plus"></span>
        </button>
        }

        @if (deviceList && (Areas.Devices | can: 'ReadWrite')) {
        <button
            id="showEmptyLocBtn"
            class="btn btn-outline-primary"
            matTooltip="{{ 'TOOLTIP_EMPTY_LOCATIONS' | translate }}"
            (click)="searchDevice.showEmpty = !searchDevice.showEmpty">
            <span [ngClass]="searchDevice.showEmpty ? 'fa-regular fa-square-check' : 'fa-light fa-square'"></span>
            {{ "SHOW_EMPTY_LOCATIONS" | translate }}
        </button>
        }

        <!-- Import locations CSV -->
         @if ((Areas.DevicesLocks | can: 'ReadWrite') && digitalKeyEnabled) {
        <button
            class="btn btn-outline-primary"
            (click)="showLockImportCard()">
            <span class="fa-light fa-fw fa-upload"></span>
            {{ "IMPORT_LOCKS_CSV" | translate }}
        </button>
        }

        <!-- Add NightOwl Service Customer ID -->
         @if (user.roleLevel >= 120) {
        <button
            class="btn btn-outline-primary"
            (click)="showNightowlCustomerIdForm()">
            <span class="fa-light fa-fw fa-plus"></span>
            {{ "ADD_NIGHTOWL_SERVICE_CUSTOMER_ID" | translate }}
        </button>
        }

    </div>






    <div class="row p-2">
        <div [ngClass]="editMode ? ['col-lg-6', 'd-none', 'd-xl-block'] : 'col-lg-12'">
            @if (!deviceListRaw && devicesLoaded) {
            <div>
                {{ "NO_DEVICES" | translate }}
            </div>
            }
            @if (generalInformationText) {
            <div class="alert alert-success" role="alert">
                {{ generalInformationText }}
            </div>
            }

            <!--Key listing-->
            @if (keyList && keyList.length > 0) {
            <div class="card">
                <div class="card-header cursorPointerHover" (click)="keyListCollapse = !keyListCollapse">
                    <h5>
                        <span class="fa-fw mr-2"
                            [ngClass]="keyListCollapse ? 'fa-light fa-key' : 'fa-solid fa-key'"></span>
                        <span class="mr-3">{{ "KEYS" | translate}}</span>
                    </h5>

                    <small>{{ "NR_OF_KEYS" | translate }}:{{ keyList.length }}</small>
                </div>

                @if (keyListCollapse) {
                <div class="card-body">
                    <table
                        class="table table-hover deviceListTable keyListTable horizontal-scroll"
                        matSort
                        (matSortChange)="sortKeys($event)">
                        <thead>
                            <tr>
                                <th style="width: 1%"></th>
                                <th mat-sort-header="id">
                                    {{ "SERIAL_NUMBER" | translate }}
                                </th>
                                <th mat-sort-header="name">
                                    {{ "DEVICE_NAME" | translate }}
                                </th>
                                <th mat-sort-header="deviceType">
                                    {{ "DEVICE_TYPE" | translate }}
                                </th>
                                <th mat-sort-header="lowBatteryWarning">
                                    {{ "DEVICE_STATUS" | translate }}
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            @for (key of keyList; track key) {
                            <tr
                                class="cursorPointer"
                                [ngClass]="{'table-active': key === selectedDev}"
                                (click)="editDevice(key.id)"
                            >
                                <td>
                                    <span
                                        class="fa-fw"
                                        [ngClass]="getDeviceIconClass(key)"
                                    ></span>
                                </td>
                                <td>{{ key.id }}</td>
                                <td>{{ key.name }}</td>
                                <td>
                                    {{ getDeviceType(key.deviceType) }}
                                </td>
                                <td>
                                    @if (key.lowBatteryWarning) {
                                    <span
                                        title="{{ 'BATTERY_STATUS_WARNING'| translate }}"
                                        class="fa-solid fa-fw fa-lg fa-battery-slash text-danger"
                                    >
                                    </span>
                                    }
                                     @if (!key.keyEnabled) {
                                    <span
                                        class="fa-light fa-fw fa-octagon-minus text-danger"
                                    ></span>
                                    }
                                </td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>
                }
            </div>
            }

            <!--Device listing-->
            @for (location of filteredDeviceList; track location; let i = $index) {
                @if (location.devices?.length > 0 || searchDevice.showEmpty) {
                <div class="card">
                    <div
                        class="card-header cursorPointerHover d-flex justify-content-between"
                        matTooltip="{{ location.name === mobileDevicesLocationUIName ? ('TOOLTIP_EXPAND_MOBILE_APPLICATIONS' | translate) : ('TOOLTIP_EXPAND_DEVICE_LIST' | translate)}}"
                        (click)="location.collapseState = !location.collapseState; changeCollapseState(location.id, location.collapseState)">
                        <div class="float-left">
                            <h5>
                                @if (location.name !== mobileDevicesLocationUIName) {
                                <span
                                    class="fa-fw mr-2"
                                    [ngClass]="location.collapseState ? 'fa-light fa-house' : 'fa-solid fa-house'"
                                    matTooltip="{{ 'TOOLTIP_LOCATION' | translate }}">
                                </span>
                                }

                                @if (location.name === mobileDevicesLocationUIName) {
                                <span
                                    class="fa-fw mr-2"
                                    [ngClass]="location.collapseState ? 'fa-light fa-mobile-screen-button' : 'fa-solid fa-mobile-screen-button'"
                                    matTooltip="{{ 'TOOLTIP_MOBILE_APPLICATIONS' | translate }}">
                                </span>
                                }

                                <span style="word-break: break-all">{{ location.name }}</span>

                                @if (location.networkFailureState) {
                                <span
                                    class="ml-3 text-danger locationNetworkFailureText">
                                    <span class="fa-light fa-fw fa-wifi-slash"></span>
                                    {{ "NETWORK_FAILURE" | translate}}
                                </span>
                                }
                            </h5>
                            <small>{{ "NR_OF_BASES" | translate }}: {{ location.baseCount ?? 0 }} / {{
                                "NR_OF_DEVICES" | translate }}: {{ location.deviceCount ?? 0 }}</small>
                        </div>

                        @if (location.name !== mobileDevicesLocationUIName) {
                        <span
                            class="fa-light fa-lg fa-pen-to-square mr-2 cursorPointerHover float-right"
                            style="margin-top: 18px"
                            data-testid="edit-location"
                            matTooltip="{{ 'TOOLTIP_EDIT_LOCATION' | translate }}"
                            (click)="editLocation(location, $event)"></span>
                        }
                    </div>

                    @if (location.collapseState) {
                    <div class="card-body">
                        @if (location.devices?.length > 0) {
                        <table
                            id="deviceListTable"
                            class="table table-borderless table-hover table-responsive deviceListTable"
                            (matSortChange)="sortDeviceList($event, i)"
                            matSort>
                            <thead>
                                <tr>
                                    <th>
                                    </th>
                                    @if (isColumnVisible('serialNumber')) {
                                    <th mat-sort-header="id">
                                        <span class="text-left">
                                            {{ "SERIAL_NUMBER" | translate }}
                                        </span>
                                    </th>
                                    }
                                    @if (isColumnVisible('deviceName')) {
                                    <th mat-sort-header="name">
                                        <span class="text-left">
                                            {{ "DEVICE_NAME" | translate }}
                                        </span>
                                    </th>
                                    }
                                    @if (isColumnVisible('deviceType')) {
                                    <th mat-sort-header="deviceType" class="deviceTypeCol">
                                        <span class="text-left">
                                            {{ "DEVICE_TYPE" | translate }}
                                        </span>
                                    </th>
                                    }
                                    @if (editMode) {
                                    <th></th>
                                    }
                                    @if (deviceResidents?.length > 0 && !editMode && isColumnVisible('resident')) {
                                    <th
                                        mat-sort-header="resident">
                                        <span class="text-left">
                                            {{ "RESIDENT" | translate }}
                                        </span>
                                    </th>
                                    }
                                    @if (!editMode && isColumnVisible('lastConnection')) {
                                    <th
                                        mat-sort-header="onlineStatus"
                                        class="d-none d-lg-table-cell d-xl-table-cell">
                                        <span class="text-left">
                                            {{ "DEVICE_LAST_CONTACT" | translate }}
                                        </span>
                                        <span class="fa fa-fw fa-circle-info"
                                            matTooltip="{{ 'TOOLTIP_DEVICE_LAST_CONNECTION'| translate }}">
                                        </span>
                                    </th>
                                    }
                                    @if (showAdditionalInfo && !editMode && isColumnVisible('deviceInfo')) {
                                    <th>
                                        {{ "DEVICE_ADDITIONAL_INFO_SHORT" | translate }}
                                    </th>
                                    }
                                    @if (showAdditionalInfo && !editMode && isColumnVisible('additionalInfo')) {
                                    <th>
                                        {{ "DEVICE_ADDITIONAL_ALARM_INFO" | translate }}
                                    </th>
                                    }
                                    @if (!editMode && isColumnVisible('externalId')) {
                                    <th>
                                        {{ "EXTERNAL_IDENTIFIER" | translate }}
                                    </th>
                                    }
                                    @if (!editMode && isColumnVisible('address')) {
                                    <th class="addressCol">
                                        {{ "ADDRESS" | translate }}
                                    </th>
                                    }
                                    <th style="width: 1%"></th>
                                </tr>
                            </thead>

                            <tbody>
                                @for (dev of location.devices; track dev; let i = $index) {
                                    <tr
                                        class="border-top cursorPointer"
                                        [ngClass]="{ collapsedTr: dev.collapseState && dev.pairedDevices, 'table-active': dev?.id === selectedDev?.id, baseHasPaired: dev.pairedDevices }"
                                        (click)="editDevice(dev.id)">
                                        <td>
                                            <div class="d-flex flex-nowrap align-items-baseline deviceListStatus">
                                                @if (dev.lowBatteryWarning) {
                                                <span
                                                    title="{{ 'BATTERY_STATUS_WARNING' | translate }}"
                                                    class="fa-solid fa-fw fa-lg fa-battery-slash text-danger"></span>
                                                }
                                                @if (dev.tasksToBase) {
                                                <span
                                                    title="{{ 'DEVICE_PARAM_TO' | translate }}"
                                                    class="fa-light fa-down-to-line fa-lg text-warning"></span>
                                                }

                                                @if (dev.tasksFromBase) {
                                                <span
                                                    title="{{ 'DEVICE_PARAM_FROM' | translate }}"
                                                    class="fa-light fa-up-from-line fa-lg text-warning"></span>
                                                }
                                                @if (dev.toBeDeleted) {
                                                <span
                                                    title="{{ 'DEVICE_MARKED_DELETE' | translate }}"
                                                    class="fa-light fa-octagon-minus text-danger"></span>
                                                }

                                                @if (dev.softwareUpdateOngoing) {
                                                <span
                                                    title="{{ 'FIRMWARE_UPDATE_ONGOING' | translate }}"
                                                    class="fa-light fa-arrows-rotate text-warning"></span>
                                                }

                                                @if (dev.muted) {
                                                <span
                                                    title="{{ 'INACTIVE' | translate }}"
                                                    class="fa-solid fa-bell-slash"></span>
                                                }

                                                @if (dev?.excluded) {
                                                <span
                                                    title="{{ 'EXCLUDED' | translate }}"
                                                    class="fa-solid fa-ban text-secondary"></span>
                                                }

                                                @if (dev.id.substr(0, 2) === '31') {
                                                <div
                                                    matTooltip="{{service.getActiveConnectionInfo(dev.signalLevels, dev.connectionType)}}"
                                                    [matTooltipPosition]="'before'">
                                                    <!-- service.getColorClass(dev.signalLevels) -->
                                                    @switch (dev.connectionType) {
                                                    @case (0) {
                                                    <span
                                                        [ngClass]="'text-dark'"
                                                        class="fa-solid fa-signal"></span>
                                                    }
                                                    @case (1) {
                                                    <span [ngClass]="'text-dark'"
                                                        class="fa-solid fa-network-wired"></span>
                                                    }
                                                    @case (2) {
                                                    <span [ngClass]="'text-dark'"
                                                        class="fa-solid fa-wifi"></span>
                                                    }
                                                    }
                                                </div>
                                                }
                                            </div>
                                        </td>

                                        @if (isColumnVisible('serialNumber')) {
                                        <td
                                            innerHTML="{{ dev.id | highlight : deviceFilter }}"
                                        ></td>
                                        }
                                        @if (isColumnVisible('deviceName')) {
                                        <td
                                            innerHTML="{{ dev.name | highlight : deviceFilter }}"
                                        ></td>
                                        }
                                        @if (isColumnVisible('deviceType')) {
                                        <td class="deviceTypeCol">
                                            <span class="fa-light fa-fw mr-1"
                                                [ngClass]="getDeviceIconClass(dev)"></span>
                                            <span
                                                innerHTML="{{ getDeviceType(dev.deviceType) | wrapHyphen | highlight : deviceFilter }}">
                                            </span>
                                        </td>
                                        }
                                        @if (editMode && isColumnVisible('deviceType')) {
                                        <td class="d-none d-lg-table-cell d-xl-table-cell">
                                            @if (!deviceService.isDeviceTypeWithoutStatus(dev.deviceType)) {
                                            <div>
                                                @if (dev.onlineStatus === 'Offline' && dev.lastConnection !== '0001-01-01T00:00:00Z' && !onlineInLastDay(dev.lastConnection)) {
                                                <i
                                                    class="fa-solid fa-fw fa-square-xmark noConnection"></i>
                                                }

                                                @if (dev.onlineStatus === 'Offline' && onlineInLastDay(dev.lastConnection)) {
                                                <i
                                                    class="fa-solid fa-fw fa-triangle-exclamation noConnectionInLast24"></i>
                                                }

                                                @if (dev.onlineStatus === 'Online' && dev.lastConnection !== '0001-01-01T00:00:00Z') {
                                                <i
                                                    class="fa-solid fa-fw fa-circle-check deviceOnlineState"></i>
                                                }
                                            </div>
                                            }

                                            <!--Timestamps for Vegas are always hidden since they are incorrect-->
                                            @if (deviceService.isDeviceTypeWithoutStatus(dev.deviceType)) {
                                            <div>-</div>
                                            }
                                        </td>
                                        }
                                        @if (deviceResidents?.length > 0 && !editMode && isColumnVisible('resident')) {
                                        <td
                                            innerHTML="{{ dev.residentDisplayName | highlight : deviceFilter }}">
                                        </td>
                                        }
                                        @if (!editMode && isColumnVisible('lastConnection')) {
                                        <td class="d-none d-lg-table-cell d-xl-table-cell">
                                            @if (!deviceService.isDeviceTypeWithoutStatus(dev.deviceType)) {
                                            <div>
                                                @if (dev.onlineStatus === 'Offline' && dev.lastConnection !== '0001-01-01T00:00:00Z' && !onlineInLastDay(dev.lastConnection)) {
                                                <i
                                                    class="fa-solid fa-fw fa-square-xmark noConnection"></i>
                                                }
                                                @if (dev.onlineStatus === 'Offline' && onlineInLastDay(dev.lastConnection)) {
                                                <i
                                                    class="fa-solid fa-fw fa-triangle-exclamation noConnectionInLast24"></i>
                                                }
                                                @if (dev.onlineStatus === 'Online' && dev.lastConnection !== '0001-01-01T00:00:00Z') {
                                                <i
                                                    class="fa-solid fa-fw fa-circle-check deviceOnlineState"></i>
                                                }

                                                {{ dev.lastConnection | moment : "l LTS" }}
                                            </div>
                                            }

                                            <!--Timestamps for Vegas are always hidden since they are incorrect-->
                                            @if (deviceService.isDeviceTypeWithoutStatus(dev.deviceType)) {
                                            <div>-</div>
                                            }
                                        </td>
                                        }
                                        @if (showAdditionalInfo && !editMode && isColumnVisible('deviceInfo')) {
                                        <td
                                            class="cutLongText"
                                            innerHTML="{{ dev.additionalInfo | highlight : deviceFilter }}">
                                        </td>
                                        }
                                        @if (showAdditionalInfo && !editMode && isColumnVisible('additionalInfo')) {
                                        <td
                                            class="cutLongText"
                                            innerHTML="{{ dev.additionalAlarmInfo | highlight : deviceFilter }}">
                                        </td>
                                        }
                                        @if (!editMode && isColumnVisible('externalId')) {
                                        <td innerHTML="{{ dev.externalSystemId | highlight : deviceFilter }}">
                                            <!--External identifier-->
                                        </td>
                                        }
                                        @if (!editMode && isColumnVisible('address')) {
                                        <td class="cutLongText addressCol">
                                            <span innerHTML="{{ dev.address | highlight : deviceFilter }}"></span><br />
                                            <span innerHTML="{{ dev.postCode + ' ' + dev.postOffice | highlight : deviceFilter }}"></span>
                                        </td>
                                        }
                                        <td>
                                            @if (dev.pairedDevices) {
                                            <span
                                                class="fa-solid fa-fw cursorPointer"
                                                [ngClass]="dev.collapseState ? 'fa-chevron-down' : 'fa-chevron-right'"
                                                (click)="collapseDeviceRow(dev, $event)">
                                            </span>
                                            }
                                        </td>
                                    </tr>
                                    @for (pairedDev of dev.pairedDevices; track pairedDev; let last = $last) {
                                    <tr
                                        [hidden]="!dev.collapseState"
                                        class="pairedDevices cursorPointer"
                                        [ngClass]="{ pairedDevicesLast: last, 'table-active': pairedDev?.id === selectedDev?.id }"
                                        (click)="editDevice(pairedDev.id)">

                                        <td
                                            class="deviceListStatus">
                                            @if (pairedDev.lowBatteryWarning) {
                                            <span
                                                title="{{ 'BATTERY_STATUS_WARNING' | translate }}"
                                                class="fa-solid fa-fw fa-lg fa-battery-slash text-danger"></span>
                                            }
                                            @if (pairedDev.tasksToBase) {
                                            <span
                                                title="{{ 'DEVICE_PARAM_TO' | translate }}"
                                                class="fa-light fa-down-to-line fa-lg text-warning"></span>
                                            }
                                            @if (pairedDev.tasksFromBase) {
                                            <span
                                                class="fa-light fa-up-from-line fa-lg text-warning"
                                                title="{{ 'DEVICE_PARAM_FROM' | translate }}"></span>
                                            }
                                            @if (pairedDev.toBeDeleted) {
                                            <span
                                                class="fa-light fa-octagon-minus text-danger"
                                                title="{{ 'DEVICE_MARKED_DELETE' | translate }}"
                                            ></span>
                                            }
                                            @if (pairedDev.replaceDevice && pairedDev.replaceDevice !== '00000000' && pairedDev.replaceDevice !== '0') {
                                            <span
                                                title="{{ 'DEVICE_MARKED_REPLACE' | translate }}"
                                                class="fa-light fa-arrow-right-arrow-left text-warning ml-2"></span>
                                            }
                                            @if (pairedDev.softwareUpdateOngoing) {
                                            <span
                                                title="{{ 'FIRMWARE_UPDATE_ONGOING' | translate }}"
                                                class="fa-light fa-arrows-rotate text-warning ml-2"></span>
                                            }
                                            @if (pairedDev.muted) {
                                            <span
                                                title="{{ 'INACTIVE' | translate }}"
                                                class="fa-solid fa-bell-slash ml-2"
                                            ></span>
                                            }
                                            @if (pairedDev.id.substr(0, 2) === '31') {
                                            <div
                                                matTooltip="{{service.getActiveConnectionInfo(pairedDev.signalLevels, pairedDev.connectionType)}}"
                                                [matTooltipPosition]="'before'">
                                                <!-- service.getColorClass(pairedDev.signalLevels) -->
                                                @switch (pairedDev.connectionType) {
                                                @case (0) {
                                                <span [ngClass]="'text-dark'"
                                                    class="fa-solid fa-signal"></span>
                                                }
                                                @case (1) {
                                                <span [ngClass]="'text-dark'"
                                                    class="fa-solid fa-network-wired"></span>
                                                }
                                                @case (2) {
                                                <span [ngClass]="'text-dark'"
                                                    class="fa-solid fa-wifi"></span>
                                                }
                                                }
                                            </div>
                                            }
                                        </td>
                                        @if (isColumnVisible('serialNumber')) {
                                            <td innerHTML="{{ pairedDev.id | highlight : deviceFilter }}"></td>
                                        }
                                        @if (isColumnVisible('deviceName')) {
                                            <td innerHTML="{{ pairedDev.name | highlight : deviceFilter }}"></td>
                                        }
                                        @if (isColumnVisible('deviceType')) {
                                        <td class="deviceTypeCol">
                                            <span
                                                class="fa-fw mr-1"
                                                    [ngClass]="getDeviceIconClass(pairedDev)"></span>
                                            @if (pairedDev.deviceType !== '15-1') {
                                            <span
                                                innerHTML="{{ getDeviceType(pairedDev.deviceType) | wrapHyphen | highlight : deviceFilter }}"></span>
                                            }
                                            @if (pairedDev.deviceType === '15-1') {
                                            <span
                                                innerHTML="{{ getDeviceLabel(pairedDev) | wrapHyphen | highlight : deviceFilter }}"></span>
                                            }
                                        </td>
                                        }                                        
                                        
                                        @if (editMode && isColumnVisible('deviceType')) {
                                        <td class="d-none d-lg-table-cell d-xl-table-cell">
                                            @if (!deviceService.isDeviceTypeWithoutStatus(pairedDev.deviceType)) {
                                                @if (pairedDev.onlineStatus === 'Offline' &&
                                                        pairedDev.lastConnection !== '0001-01-01T00:00:00Z' &&
                                                        !onlineInLastDay(pairedDev.lastConnection)) {
                                                <i
                                                    class="fa-solid fa-fw fa-square-xmark noConnection">
                                                </i>
                                                }

                                                @if (pairedDev.onlineStatus === 'Offline' && onlineInLastDay(pairedDev.lastConnection)) {
                                                <i
                                                    class="fa-solid fa-fw fa-triangle-exclamation noConnectionInLast24">
                                                </i>
                                                }

                                                @if (pairedDev.onlineStatus === 'Online' && pairedDev.lastConnection !== '0001-01-01T00:00:00Z') {
                                                <i
                                                    class="fa-solid fa-fw fa-circle-check deviceOnlineState">
                                                </i>
                                                }
                                            }
                                        </td>
                                        }
                                        @if (deviceResidents?.length > 0 && !editMode && isColumnVisible('resident')) {
                                        <td
                                            innerHTML="{{ pairedDev.residentDisplayName | highlight : deviceFilter }}">
                                        </td>
                                        }
                                        @if (!editMode && isColumnVisible('lastConnection')) {
                                        <td class="d-none d-lg-table-cell d-xl-table-cell">
                                            @if (!deviceService.isDeviceTypeWithoutStatus(pairedDev.deviceType) && isColumnVisible('lastConnection')) {
                                            @if (pairedDev.onlineStatus === 'Offline' &&
                                                        pairedDev.lastConnection !== '0001-01-01T00:00:00Z' &&
                                                        !onlineInLastDay(pairedDev.lastConnection)) {
                                            <i
                                                class="fa-solid fa-fw fa-square-xmark noConnection"></i>
                                            }

                                            @if (pairedDev.onlineStatus === 'Offline' && onlineInLastDay(pairedDev.lastConnection)) {
                                            <i
                                                class="fa-solid fa-fw fa-triangle-exclamation noConnectionInLast24"></i>
                                            }

                                            @if (pairedDev.onlineStatus === 'Online' && pairedDev.lastConnection !== '0001-01-01T00:00:00Z') {
                                            <i
                                                class="fa-solid fa-fw fa-circle-check deviceOnlineState"></i>
                                            }

                                            {{ pairedDev.lastConnection | moment : "l LTS" }}
                                            }
                                        </td>
                                        }
                                        @if (showAdditionalInfo && !editMode && isColumnVisible('deviceInfo')) {
                                        <td
                                            class="cutLongText"
                                            innerHTML="{{ pairedDev.additionalInfo | highlight : deviceFilter }}">
                                        </td>
                                        }
                                        @if (showAdditionalInfo && !editMode && isColumnVisible('additionalInfo')) {
                                        <td
                                            class="cutLongText"
                                            innerHTML="{{ pairedDev.additionalAlarmInfo | highlight : deviceFilter }}">
                                        </td>
                                        }
                                        @if (!editMode && isColumnVisible('externalId')) {
                                        <td
                                            innerHTML="{{ pairedDev.externalSystemId | highlight : deviceFilter }}">
                                            <!--External identifier-->
                                        </td>
                                        }
                                        @if (!editMode && isColumnVisible('address')) {
                                        <td class="cutLongText addressCol">
                                            {{ pairedDev.address }}<br />
                                            {{ pairedDev.postCode }} {{ pairedDev.postOffice }}
                                        </td>
                                        }
                                        <td>

                                        </td>
                                    </tr>
                                    }
                                }
                            </tbody>
                        </table>
                        } @else {
                        <div class="mb-2">
                            {{ "LOCATION_NO_DEVICES" | translate }}
                        </div>
                        }
                    </div>
                    }
                </div>
                }
            }


            <div class="justify-content-center">
                @if (!deviceList && !devicesLoaded) {
                <div>
                    <img
                        class="fadeLoader centerLoader logoSmall"
                        src="assets/img/loading_logo.svg" />
                </div>
                }
            </div>
        </div>

        <!-- Card for editing existing device. Show if editMode is true and device with prefix other than F0 and class 1 is selected -->
        @if (editMode && selectedDev && selectedDev.deviceType !== 'F0-1') {
        <div class="col-xl-6">
            <div class="card stickyCard connect-card" style="width: 100%">
                <div class="card-header-white header-underline" style="padding-bottom: 20px; padding-top: 10px">
                    <div style="position: relative; display: inline-block; top: 25%;">
                        <h6>
                            @if (selectedDev.name) {
                            <span>
                                {{ selectedDev.name }} ({{ selectedDev.id}})
                            </span>
                            } @else {
                            <span>{{ selectedDev.id }}</span>
                            }
                        </h6>
                    </div>

                    <div style="position: relative; display: inline-block; top: 25%;">
                        @if (selectedDev.tasksToBase) {
                        <span title="{{ 'DEVICE_PARAM_TO' | translate }}"
                            class="fa-light fa-down-to-line fa-lg text-warning ml-2"></span>
                        }

                        @if (selectedDev.tasksFromBase) {
                        <span title="{{ 'DEVICE_PARAM_FROM' | translate }}"
                            class="fa-light fa-up-from-line fa-lg text-warning ml-2"></span>
                        }

                        @if (selectedDev.toBeDeleted) {
                        <span
                            title="{{ 'DEVICE_MARKED_DELETE' | translate }}"
                            class="fa-light fa-octagon-minus text-danger ml-2"></span>
                        }

                        @if (selectedDev.id.substr(0, 2) !== '31' &&
                                selectedDev.replaceDevice &&
                                selectedDev.replaceDevice !== '00000000' &&
                                selectedDev.replaceDevice !== '0') {
                        <span
                            title="{{ 'DEVICE_MARKED_REPLACE' | translate }}"
                            class="fa-light fa-arrow-right-arrow-left text-warning ml-2">
                        </span>
                        }

                        @if (selectedDev.softwareUpdateOngoing) {
                        <span
                            title="{{ 'FIRMWARE_UPDATE_ONGOING' | translate }}"
                            class="fa-light fa-arrows-rotate text-warning ml-2"></span>
                        }
                        @if (selectedDev?.muted) {
                        <span
                            title="{{ 'INACTIVE' | translate }}"
                            class="fa-solid fa-bell-slash ml-2" [ngClass]="{'cursorPointer': canUnmute}" (click)="canUnmute ? openUnmutePopup() : null"></span>
                        }
                    </div>
                    @if (showUnmutePopup) {
                    <div class="custom-backdrop">
                        <div class="custom-modal">
                          <h5>{{'UNMUTE_DEVICE' |translate}}</h5>
                          <p>{{'CONFIRM_ACTIVATE' |translate}}</p>
                      
                          <button class="btn btn-outline-danger mr-2" (click)="closeUnmutePopup()">{{'CANCEL' |translate}}</button>
                          <button class="btn btn-primary" (click)="confirmUnmute()">{{'ACTIVATE' |translate}}</button>
                        </div>
                      </div>
                    }

                    <span class="cursorPointer" (click)="editDevice(selectedDev.id)">
                        <span class="fa-light fa-xmark float-right"
                            style=" position: relative; margin-right: 15px; top: 30%;"></span>
                    </span>
                </div>

                <div class="card-body-white">
                    @if (selectedDevInfoLoaded) {
                    <div>
                        <div class="mb-2">
                            <ul class="list-inline">
                                <li class="list-inline-item">
                                    <span class="editPageTab" [ngClass]="{ 'editPageTab-active': editModePage === 0 }"
                                        (click)="editModePage = 0">
                                        {{ "INFORMATION" | translate }}
                                    </span>
                                </li>
                                @if ((Areas.DevicesNfc | can: 'ReadWrite') && !deviceManagementEmpty && selectedDev.deviceType === '08-1') {
                                <li class="list-inline-item">
                                    <span
                                        class="editPageTab"
                                        [ngClass]="{ 'editPageTab-active': editModePage === 4 }"
                                        (click)="editModePage = 4; devInformationText = ''">
                                        {{ "CONNECT_DEVICE" | translate}}
                                    </span>
                                </li>
                                }
                                @if (showDeviceSettings(selectedDevInfo) && (Areas.Devices | can)) {
                                <li
                                    matTooltip="{{ 'TOOLTIP_DEVICE_SETTINGS' | translate }}" class="list-inline-item">
                                    <span class="editPageTab" [ngClass]="{ 'editPageTab-active': editModePage === 3 }"
                                        (click)=" editModePage = 3; devInformationText = ''">
                                        {{ "SETTINGS" | translate }}
                                    </span>
                                </li>
                                }

                                @if (canOpenDeviceControl && !deviceManagementEmpty) {
                                <li
                                    matTooltip="{{ 'TOOLTIP_DEVICE_CONTROL' | translate }}" class="list-inline-item">
                                    <span class="editPageTab" [ngClass]="{ 'editPageTab-active': editModePage === 1 }"
                                        (click)="editModePage = 1; devInformationText = ''">
                                        {{ "DEVICE_CONTROL" | translate}}
                                    </span>
                                </li>
                                }
                                @if (selectedDev.deviceType === '31-7' ||
                                        selectedDev.deviceType === '40-1' ||
                                        selectedDev.deviceType === '31-8') {
                                <li
                                    class="list-inline-item">
                                    <span class="editPageTab" [ngClass]="{ 'editPageTab-active': editModePage === 2 }"
                                        (click)="editModePage = 2; devInformationText = ''">
                                        {{ "DISPLAY_CONFIGURATION" | translate }}
                                    </span>
                                </li>
                                }
                            </ul>
                        </div>
                        <!--Rotated door ID: the same ID is in use on another device in this customer account-->
                        @if (doorIdShared) {
                        <div class="alert alert-warning" role="alert">
                            <span class="fa-light fa-triangle-exclamation mr-2"></span>
                            {{ "DOOR_ID_SHARED_WARNING" | translate: { doorId: sharedDoorId } }}
                            <!--Door IDs cannot be searched for, so name the conflicting devices here-->
                            @if (sharedDoorIdDevices.length > 0) {
                            <div class="mt-2">
                                <strong>{{ "DOOR_ID_SHARED_DEVICES" | translate }}</strong>
                                <ul class="mb-0 pl-4">
                                    @for (sharedDevice of sharedDoorIdDevices; track sharedDevice) {
                                    <li>
                                        <strong>{{ sharedDevice.deviceId }}</strong>
                                        @if (sharedDevice.name) {
                                        <span> &ndash; {{ sharedDevice.name }}</span>
                                        }
                                        @if (sharedDevice.locationName) {
                                        <span> ({{ sharedDevice.locationName }})</span>
                                        }
                                    </li>
                                    }
                                </ul>
                            </div>
                            }
                        </div>
                        }

                        @if (devInformationText) {
                        <div class="alert alert-success">
                            {{ devInformationText }}
                        </div>
                        }
                        @if (devUpdateError) {
                        <div class="alert alert-danger">
                            {{ "ERROR" | translate }}
                        </div>
                        }

                        @if (editModePage === 0) {
                        <device-info
                            [device]="selectedDevInfo"
                            [locations]="locationList"
                            [residents]="deviceResidents"
                            (updateDev)="updateDev($event)"
                            (updateError)="updateError($event)"></device-info>
                        }

                        @if (editModePage === 4 && selectedDev?.deviceType === '08-1') {
                        <device-connect
                        [device]="selectedDev"
                        [tagId]="$safeNavigationMigration(selectedDev?.id)">
                        </device-connect>
                        }
                        @if (editModePage === 3) {
                        <device-settings
                            [device]="selectedDevInfo"></device-settings>
                        }

                        @if (editModePage === 1 || !isDeviceManagementEmptyChecked) {
                        <device-control
                            [device]="selectedDevInfo"
                            [pairedDevices]="selectedDev.pairedDevices"
                            [basestationList]="basestationList"
                            (isDeviceManagementEmpty)="onDeviceManagementEmpty($event)"
                            (nfcMoved)="nfcMoved($event)"
                            (doorIdOverridden)="onDoorIdOverridden()"
                            (deviceReplaced)="deviceReplaced($event)"
                            (deviceForceDeleted)="deviceForceDeleted($event)"
                            (deviceDeleted)="deviceDeleted($event)"
                            (cancelDeviceDelete)="cancelDeviceDelete($event)"
                            (settingsTransferred)="settingsTransferred($event)"
                            (settingTransferCancelled)="settingTransferCancelled($event)"
                            (updateError)="updateError($event)"
                            [hidden]="!isDeviceManagementEmptyChecked"></device-control>
                        }

                        @if (editModePage === 2) {
                        <displayconfig
                            [id]="selectedDev.id"></displayconfig>
                        }
                    </div>
                    }
                    @if (!selectedDevInfoLoaded) {
                    <div>
                        <img
                            class="fadeLoader centerLoader logoSmall"
                            src="assets/img/loading_logo.svg" />
                    </div>
                    }
                </div>
            </div>
        </div>
        }

        <!-- Card for editing existing key. Show it if editMode is true and device with prefix F0 and class 1 is selected -->
        @if (editMode && selectedDev && selectedDev.deviceType === 'F0-1') {
        <div class="col-xl-6 col-lg-12">
            <div class="card stickyCard" style="padding-bottom: 10px">
                <div class="card-header-white header-underline">
                    <h6 class="white-header-text">
                        @if (selectedDev.name) {
                        <span>
                            {{ selectedDev.name }} ({{ selectedDev.id }})
                        </span>
                        } @else {
                        <span>{{ selectedDev.id }}</span>
                        }

                        <span class="float-right cursorPointer" (click)="editDevice(selectedDev.id)">
                            <span class="fa-light fa-xmark" style="margin-right: 15px"></span>
                        </span>
                    </h6>
                </div>

                <div class="card-body-white">
                    @if (selectedDevInfoLoaded) {
                    <div>
                        @if (devInformationText) {
                        <div class="alert alert-success">
                            {{ devInformationText }}
                        </div>
                        }
                        @if (devUpdateError) {
                        <div class="alert alert-danger">
                            {{ "ERROR" | translate }}
                        </div>
                        }

                        <device-key-info
                            [device]="selectedDevInfo"
                            (updateKey)="updateKey($event)"
                            (updateError)="updateError($event)"></device-key-info>
                    </div>
                    }
                    @if (!selectedDevInfoLoaded) {
                    <div>
                        <img
                            class="fadeLoader centerLoader logoSmall"
                            src="assets/img/loading_logo.svg" />
                    </div>
                    }
                </div>
            </div>
        </div>
        }
        <!-- Card for adding new device. Show it if editMode is set to true and no device or location is selected -->
        @if (editMode && !selectedDev && !selectedLocation && !lockImport && !showNightowlCustomerId) {
        <div class="col-xl-6 col-lg-12">
            <div class="stickyCard">
                @if (user.roleLevel >= 200) {
                <app-add-device-admin-form
                  [locations]="locationList"
                  (closeEvent)="editMode = false"
                  (savedEvent)="deviceAdded($event)"
                ></app-add-device-admin-form>
                } @else {
                <device-add
                  [locationList]="locationList"
                  (closeAddFormEvent)="closeAddBaseForm()"
                  (deviceAddedEvent)="deviceAdded($event)">
                </device-add>
                }
            </div>
        </div>
        }
        <!--Card for editing location. Show it if editMode is true and no device is selected but location with id is selecter-->
        @if (editMode && !selectedDev && selectedLocation && selectedLocation.id) {
        <div class="col-xl-6 col-lg-12">
            <location-info
                [location]="selectedLocation"
                [devices]="deviceListRaw"
                (locationDeletedEvent)="locationDeleted($event)"
                (locationUpdateEvent)="locationUpdated($event)"
                (closeLocationCardEvent)="editLocation($event)">
            </location-info>
        </div>
        }

        <!--Card for editing location. Show it if editMode is true and no device is selected but location without id is selected-->
        @if (editMode && !selectedDev && selectedLocation && !selectedLocation.id) {
        <div class="col-xl-6 col-lg-12">
            <location-add
                [location]="selectedLocation"
                (locationAddedEvent)="locationAdded($event)"
                (closeLocationCardEvent)="editLocation($event)">
            </location-add>
        </div>
        }

        <!--Card for lock CSV import-->
        @if (lockImport) {
        <div class="col-xl-6 col-lg-12">
            <device-import-lock-csv (closeLockImportCardEvent)="showLockImportCard()"></device-import-lock-csv>
        </div>
        }

        <!-- Card for adding nightowl service customer id-->
        @if (showNightowlCustomerId && user.roleLevel >= 120) {
        <div class="col-xl-6 col-lg-12">
            <nightowl-service-customer-id 
                (closeFormEvent)="handleNightowlFormClosed($event)">
            </nightowl-service-customer-id>
        </div>
        }
    </div>
</div>
